import { PencilIcon } from "@heroicons/react/outline";
import React, { Fragment, useState } from "react";
import Layout from "../../../components/layout";
import DataTable from "../../../components/dataTable";
import { useHistory, useLocation } from "react-router-dom";
import LayoutError from "../../../components/layoutError";
import { useAsync } from "react-async";
import { getDisciplinesGroupsWithRules } from "../../../api/services/disciplineService";
import DisciplineGroupWithRules from "../../../api/models/disciplineGroupWithRules";
import { Notification } from '../../../components/notifications';

type ViewState = {
    message?: string;
};

const ViewDisciplineGroupRules = () => {
    const { state } = useLocation<ViewState>();

    const columns = React.useMemo(
        () => [
            {
                Header: 'Group Name',
                accessor: (d: any) => d.name,
                width: 200,
            },
            {
                id: 'rulesSet',
                Header: 'Rules Set',
                accessor: (d: any) => d.rulesSet ? "Y" : "N",
            },
            {
                accessor: 'disciplineGroupId',
                disableSortBy: true,
                Cell: () => {
                    return (
                        <div className='clearfix'>
                            <span className='float-right'>
                                <PencilIcon className="w-5 h-5 cursor-pointer" aria-hidden="true" />
                            </span>
                        </div>
                    );
                },
                wdith: 50,
                className: "hidden sm:table-cell"
            },
        ],
        []
    );

    const [treatmentTypes, setTreatmentTypes] = useState<DisciplineGroupWithRules[]>([]);
    const history = useHistory();

    const { error, isPending } = useAsync({
        promiseFn: getDisciplinesGroupsWithRules,
        onResolve: (r) => {
            setTreatmentTypes(r.data.disciplineGroupRules);
        },
    });

    if (error) return <LayoutError />;

    return (
        <Layout
            isLoading={isPending}
        >
            <Fragment>
                {state?.message && <Notification message={state?.message} />}
                <DataTable
                    columns={columns}
                    data={treatmentTypes}
                    showPagination={true}
                    getRowProps={(row: any) => ({
                        onClick: () => history.push(`/admin/disciplineGroupRules/${row.values.disciplineGroupId}`),
                        className: "cursor-pointer hover:bg-gray-100",
                    })}
                />
            </Fragment>
        </Layout>
    )
}

export default ViewDisciplineGroupRules;